import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Textfield } from 'react-mdl'

export class Settings extends Component {

  static propTypes = {
    fields: PropTypes.array.isRequired //array of objects with keys: name, label, value
  }

  constructor(props,context) {
    super(props,context);

    this.state = this.defaultState()

    this.handleTextFieldChange = this.handleTextFieldChange.bind(this);
  }

  defaultState() {
    const state = {}
    for (var i = 0; i < this.props.fields.length; i++) {
      const field = this.props.fields[i]
      state[field.name] = field.value
    }
    return state
  }

  render(){
    return (<div>
            {
            this.props.fields.map((field) => (
              <div key={field.name}>
              <Textfield name={field.name} onChange={this.handleTextFieldChange} label={field.label} floatingLabel style={{width: '200px'}} value={this.state[field.name]} required />
              </div>
            ),this)
            }
            </div>
    )
  }

  handleTextFieldChange(event) {
    const newState = {...this.state}
    newState[event.target.name] = event.target.value;
    this.setState(newState);
  }
}

export default Settings



// WEBPACK FOOTER //
// ./src/components/Settings.js